import React, {FC} from "react"
import authentication from "@irati/auth"
import {PERKS, RECOGNITION} from "@irati-tracking/tracker/products"
import platformTracking from "@irati-tracking/platform"
import recognitionTracking from "@irati-tracking/recognition/navigation"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import HeaderLink from "./HeaderLink"

interface CurrentProductsIconProps {
  isPerksSection?: boolean
  isCelebrationSection?: boolean
}

const MyProductAccount: FC<CurrentProductsIconProps> = ({isPerksSection, isCelebrationSection}) => {
  if (!authentication.isLoggedIn() || (!isPerksSection && !isCelebrationSection)) {
    return null
  }

  const handleClick = () => {
    if (isPerksSection) {
      platformTracking.click("order_history", {source: "header"})
    } else {
      recognitionTracking.clickMyCelebrations({source: "header"})
    }
  }

  return (
    <HeaderLink
      to={isPerksSection ? "/account/my-perks/new" : "/account/my-recognition/"}
      onClick={handleClick}
      id={isPerksSection ? "link-my-perks" : "link-my-celebrations"}
      app={isPerksSection ? PERKS : RECOGNITION}
      marginLeft={.5}>
      <Icon icon={isPerksSection ? IconTypes.perks : IconTypes.celebration} size={24} />
    </HeaderLink>
  )
}

export default MyProductAccount
